import React, { CSSProperties } from 'react';
import styles from './index.less';
import { NumberInput, NumberInputFrom } from '@frame//components/property-editor/editor-components/number-input-new';

interface ICustomSelect {
    value?: string | number;
    defaultValue?: number;
    suffix?: string;
    min: number;
    max: number;
    step: number;
    toFixed?: number;
    allowDecimal?: boolean;
    disabled?: boolean;
    maxLength?: number;
    inputStyle?: CSSProperties;
    style?: CSSProperties;
    placeholder?: string;
    noButtons?: boolean;
    onChange?: (value: string, from?: NumberInputFrom) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    wrapperStyle?: React.CSSProperties;
    label?: string;
    width?: number;
    height?: number;
    labelStyle?: React.CSSProperties;
}

/**
 * wb的toolbar没有数字输入，做个自定义的，等wb支持吧
 */
export class CustomNumberInput extends React.Component<ICustomSelect, any> {
    render() {
        let { value } = this.props;
        value = Number(value).toFixed(2);
        return <div
            className={styles['wb-custom-input']}
            style={{
                ...this.props.wrapperStyle,
            }}
        >
            {
                this.props.label && <div
                    className={styles['wb-custom-input-label']}
                    style={this.props.labelStyle}
                >{this.props.label}</div>
            }
            <div
                className={styles['wb-custom-number-input-container']}
            >
                <NumberInput
                    style={{
                        width: this.props.width ?? 100,
                        height: this.props.height ?? 24,
                    }}
                    inputStyle={{
                        height: this.props.height ?? 24,
                    }}
                    {...this.props}
                    value={value}
                />
            </div>
        </div>;
    }
}
